import React from 'react';
import classes from './Modal.css';
import Aux from '../../../hoc/Aux';
import Backdrop from '../Backdrop/Backdrop';
const modal = (props) => (
    <Aux>
        <Backdrop show={props.show} clicked={props.modalClosed} />
        <div className={classes.Modal}
            style={{
                transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
                opacity: props.show ? '1' : '0'
            }}>
            <button
                className={classes.CloseModal}
                onClick = {props.modalClosed}
            >&times;</button>
            {props.children}
        </div>
    </Aux>
);

export default modal;


// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js